import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import client, { apiError } from '../api/client';

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    fullName: '', email: '', password: '', focusDomain: 'all', targetExamDate: '', distributionSource: '',
  });
  const [error, setError] = useState('');
  const [info, setInfo] = useState('');
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError(''); setInfo(''); setLoading(true);
    try {
      const { data } = await client.post('/auth/register', form);
      setInfo(data.message);
      setTimeout(() => navigate(`/verify?email=${encodeURIComponent(form.email)}`), 900);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-narrow" style={{ marginTop: 48 }}>
      <div className="card card-pad-lg">
        <h1>Create your account</h1>
        <p className="muted small">Start revising for the PMP in a few steps.</p>
        <div className="divider" />
        {error && <div className="alert alert-error" style={{ marginBottom: 14 }}>{error}</div>}
        {info && <div className="alert alert-ok" style={{ marginBottom: 14 }}>{info}</div>}
        <form onSubmit={submit}>
          <div className="field">
            <label>Full name</label>
            <input value={form.fullName} onChange={set('fullName')} required />
          </div>
          <div className="field">
            <label>Email</label>
            <input type="email" value={form.email} onChange={set('email')} required />
          </div>
          <div className="field">
            <label>Password</label>
            <input type="password" value={form.password} onChange={set('password')} required minLength={8} />
            <div className="hint">At least 8 characters.</div>
          </div>
          <div className="field">
            <label>Study focus</label>
            <select value={form.focusDomain} onChange={set('focusDomain')}>
              <option value="all">All domains</option>
              <option value="people">People (33%)</option>
              <option value="process">Process (41%)</option>
              <option value="business-environment">Business Environment (26%)</option>
            </select>
            <div className="hint">Personalises your study — the assistant still covers all of PMP.</div>
          </div>
          <div className="field">
            <label>Target exam date (optional)</label>
            <input type="date" value={form.targetExamDate} onChange={set('targetExamDate')} />
          </div>
          <div className="field">
            <label>How did you hear about us? (optional)</label>
            <input value={form.distributionSource} onChange={set('distributionSource')} placeholder="Training provider, colleague, direct…" />
          </div>
          <button className="btn btn-primary btn-block" style={{ marginTop: 18 }} disabled={loading}>
            {loading ? <span className="spinner" /> : 'Create account'}
          </button>
        </form>
        <p className="small muted center" style={{ marginTop: 16 }}>
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
